import { render, staticRenderFns } from "./duoDynamicForm.vue?vue&type=template&id=1fb2347e&scoped=true&"
import script from "./duoDynamicForm.vue?vue&type=script&lang=js&"
export * from "./duoDynamicForm.vue?vue&type=script&lang=js&"
import style0 from "./duoDynamicForm.vue?vue&type=style&index=0&id=1fb2347e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2347e",
  null
  
)

export default component.exports